import React from 'react';
import PropTypes from 'prop-types';
import { Button, TableCell, TableRow } from '@tempmee/react';
import { useGetMemberRateLimits } from '../../../../domain/OfficeRateLimits';
import { TableCardFrame, TableCardTitle } from '../../../commonComponents/TableCardFrame';
import { RATE_LIMIT_PROFESSIONS } from '../constants';
import { toRateLimitLabel } from '../utils';

const COLUMNS = ['Organization', ...RATE_LIMIT_PROFESSIONS.map(({ label }) => label)];

const CARD_TITLE = <TableCardTitle>Rate Limits</TableCardTitle>;

/**
 * The identity's hourly rate limits, one row per organization it belongs to,
 * from organization-service. Read-only: the editor is GOTU-15778.
 */
export const RateLimitsTable = ({ identityId }) => {
  const {
    data: memberships = [], isPending, isError, refetch,
  } = useGetMemberRateLimits(identityId);

  return (
    <TableCardFrame
      title={CARD_TITLE}
      outline
      action={
        isError ? (
          <Button variant="outlined" color="secondary" size="small" onClick={() => refetch()}>
            Retry
          </Button>
        ) : null
      }
      columns={COLUMNS}
      rowCount={memberships.length}
      isPending={isPending}
      isError={isError}
      emptyMessage="This location user belongs to no organization."
      errorMessage="Could not load rate limits."
    >
      {memberships.map((membership) => (
        <TableRow key={membership.organizationId}>
          {/* organization-service omits the name when it has none; the id is
              still something an admin can look up. */}
          <TableCell>{membership.organizationName || membership.organizationId}</TableCell>
          {RATE_LIMIT_PROFESSIONS.map(({ key }) => (
            <TableCell key={key}>{toRateLimitLabel(membership.rateLimits[key])}</TableCell>
          ))}
        </TableRow>
      ))}
    </TableCardFrame>
  );
};

RateLimitsTable.propTypes = {
  identityId: PropTypes.string.isRequired,
};

export default RateLimitsTable;
